import { useRecoilValue } from "recoil";
import DynamicIcon from "./DynamicIcon";
import { iconsData, iconsLoaded } from "../../../service/memory/recoil/theme";
import "./smarticon.css"

const SmartIcon = ({
  iconKey,
  width = 24,
  height = 24,
  handleIconClick,
  color,
}) => {
  const loaded = useRecoilValue(iconsLoaded);
  const icons = useRecoilValue(iconsData);
  const iconURL = icons?.[iconKey];

  if (!loaded || !iconURL) {
    return (
      <div
        style={{
          width,
          height,
          background:
            "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.2s infinite",
        }}
      />
    );
  }

  return (
    <DynamicIcon
      iconURL={iconURL}
      width={width}
      height={height}
      handleIconClick={handleIconClick}
      color={color}
    />
  );
};

export default SmartIcon;
